var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dl",
    { staticClass: "row" },
    [
      _c("dt", { staticClass: "col-sm-5" }, [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _vm._l(_vm.files, function(file, index) {
        return _vm.files.length >= 1
          ? [
              _c("dd", { staticClass: "col-sm-6" }, [
                _c("span", { staticClass: "text-left" }, [
                  _c(
                    "a",
                    {
                      staticClass: "file-link",
                      on: {
                        click: function($event) {
                          return _vm.downloadFile(file)
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fad", "download"] }
                      }),
                      _vm._v("\n          - " + _vm._s(file.bestandsnaam))
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("dd", { staticClass: "col-sm-5" })
            ]
          : [
              _c("dd", { staticClass: "col-sm-6 text-left" }, [
                _vm._v("\n      Geen bijlagen\n    ")
              ])
            ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }